var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table-drawer',{ref:"tableDrawer",attrs:{"handler":"brandOrField","url":"/get","toolbar":_vm.toolbar,"columns":_vm.columns,"formItems":_vm.formItems,"beginAddBefor":_vm.beginAddBefor,"rules":_vm.rules,"sendJson":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }